import { ohQueryClient } from "@shared/libs/react-query/query-client";
import { logout } from "hassibot/services_v2/login";
import { mtLogger } from "shared-core";
import {
  APP_UPDATE_REQUIRED,
  BROADCAST_CHANNEL_APP_UPDATE,
  listenOnBroadcastChannel,
} from "startup/custom-broadcast-channel";

// Databases to preserve during cleanup (will not be deleted)
const PRESERVED_DATABASES = ["ouihelp-local", "hassibot-documents2"] as const;

// Flag to prevent infinite loops
let isHandlingUpdate = false;

// Listen for app update messages from other tabs
listenOnBroadcastChannel(BROADCAST_CHANNEL_APP_UPDATE, async event => {
  if (event.data?.type === APP_UPDATE_REQUIRED && !isHandlingUpdate) {
    mtLogger.debug("Received APP_UPDATE_REQUIRED message");
    isHandlingUpdate = true;

    try {
      // Clear localStorage
      localStorage.clear();

      // Clear IndexedDB
      if (indexedDB.databases) {
        const idbDatabases = await indexedDB.databases();

        const databasesToDelete = idbDatabases.filter(
          db => !PRESERVED_DATABASES.includes(db.name as any)
        );

        await Promise.all(
          databasesToDelete.map(idbDatabaseInfo =>
            indexedDB.deleteDatabase(idbDatabaseInfo.name as string)
          )
        );
      }

      // Clear React Query cache
      ohQueryClient.clear();

      // Handle service worker last
      if ("serviceWorker" in navigator) {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration) {
          // Wait a bit to ensure other tabs have received the message
          await new Promise(resolve => setTimeout(resolve, 1000));
          await registration.unregister();
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
        }
      }

      // Logout and reload after everything is cleared
      logout();
      window.location.reload();
    } catch (error) {
      console.error("Error during app update:", error);
      isHandlingUpdate = false;
    }
  }
});
